// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.color {\r\n  font-family: \"Microsoft YaHei\", 微软雅黑, \"MicrosoftJhengHei\", 华文细黑, STHeiti, MingLiu;\r\n  font-size: large;\r\n  margin-top: 0;\r\n  border: 0px solid red;\r\n  text-align: center;\n}\r\n", ""]);
// Exports
module.exports = exports;
